import AppContext from 'App/AppContext';
import { IPSpinner, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall } from 'globalStyles';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { resolveISOControlReferenceUrl } from 'services/Api/isoControlService';
import { parsePositiveIntegerRouteParam } from 'utils/url';

// /references/isocontrol/{id}: the portable link target, replaced by the organization's own requirement or control.
const ISOControlReferenceRoute = () => {
  const app = useContext(AppContext);
  const history = useHistory();
  const { isoControlId } = useParams<{ isoControlId: string }>();
  const { t } = useTranslation(['translation']);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (app.isAuthInProgress || !app.isAuthenticated) return;
    const id = parsePositiveIntegerRouteParam(isoControlId);
    if (id === undefined) {
      setFailed(true);

      return;
    }
    let active = true;
    setFailed(false);
    resolveISOControlReferenceUrl(app, id).then((url) => {
      if (!active) return;
      if (url) history.replace(url);
      else setFailed(true);
    });

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isoControlId, app.isAuthInProgress, app.isAuthenticated, history]);

  return (
    <IPStack tokens={globalStackTokensGapSmall}>
      {failed ? <IPText>{t('translation:RichText.Reference.DestinationUnavailable')}</IPText> : <IPSpinner />}
    </IPStack>
  );
};

export default ISOControlReferenceRoute;
